import request from "../http/index";

/**
 * 寄售库存 - 列表
 */
export async function ConsignStockByCustomerList(data = {}) {
	const res = await request.post("/api/wms/ConsignStockByCustomer/List", data);
	return res.data;
}

/**
 * 寄售库存 - 导出
 */
export async function ConsignStockByCustomerExport(data = {}) {
	const res = await request.post("/api/wms/ConsignStockByCustomer/Export", data, {
		responseType: "blob",
	});
	return res.data;
}

/**
 * 寄售库存 - 下载模板
 */
export async function ConsignStockByCustomerDownloadTemplet(data = {}) {
	const res = await request.post("/api/wms/ConsignStockByCustomer/DownloadTemplet", data);
	return res.data;
}

/**
 * 寄售库存 - 导入
 */
export async function ConsignStockByCustomerImport(data = {}) {
	const res = await request.post("/api/wms/ConsignStockByCustomer/Import", data, {
		headers: {
			"Content-Type": "multipart/form-data;"
		},
	});
	return res.data;
}
